import { html } from 'lit';
const GithubPanel =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M12 3c-4.972 0-9 4.13-9 9.228 0 4.083 2.576 7.532 6.154 8.754.45.081.619-.196.619-.438 0-.22-.012-.946-.012-1.719-2.261.427-2.846-.565-3.026-1.084-.101-.265-.54-1.084-.923-1.303-.315-.173-.764-.6-.01-.612.708-.011 1.214.67 1.383.946.81 1.396 2.104 1.004 2.621.762.079-.6.315-1.004.574-1.235-2.003-.23-4.095-1.026-4.095-4.556 0-1.003.349-1.834.922-2.48-.09-.23-.404-1.176.09-2.445 0 0 .754-.242 2.476.946a8.2 8.2 0 0 1 2.25-.312c.765 0 1.53.104 2.25.312 1.72-1.2 2.474-.946 2.474-.946.495 1.269.18 2.215.09 2.445.574.646.923 1.465.923 2.48 0 3.541-2.104 4.326-4.106 4.556.326.289.607.842.607 1.707 0 1.235-.011 2.227-.011 2.538 0 .242.169.53.619.438a9.04 9.04 0 0 0 4.439-3.366A9.4 9.4 0 0 0 21 12.228C21 7.129 16.973 3 12 3" clip-rule="evenodd"/>
  </svg>
`;
export default GithubPanel;
